/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 */

import type { Messages } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction } from 'redux-actions'
import { RECEIVE_BUILDING_DATA, RECEIVE_LISTING_DATA } from '../constants'
import type { ActionTypes } from '../types'

export const propertyDetails = combineReducers<Messages['propertyDetails'], ActionTypes>({
  listing: handleAction<
    Messages['propertyDetails']['listing'],
    ActionTypes,
    typeof RECEIVE_LISTING_DATA
  >(
    RECEIVE_LISTING_DATA,
    (state, action) => {
      const { payload } = action
      return {
        ...state,
        [payload.listingId]: payload.property,
      }
    },
    {}
  ),
  building: handleAction<
    Messages['propertyDetails']['building'],
    ActionTypes,
    typeof RECEIVE_BUILDING_DATA
  >(
    RECEIVE_BUILDING_DATA,
    (state, action) => {
      const { payload } = action
      return {
        ...state,
        [payload.buildingId]: payload.property,
      }
    },
    {}
  ),
})
